module.exports = "/images/download-atto.svg?f47075afaf155b078745697e5df4f2bb";